<ngx-material-popover [popoverContent]="popoverContent" [clickOutToClose]="true" [xPosition]="xPosition"
  [yPosition]="yPosition" [clickOutToClose]="true" (onClose)="popoverClosed($event)" (onOpen)="popoverOpened($event)" #popover="ngxMaterialPopover"
  mode="toggle">
  <button mat-raised-button matTooltip="Saved Views" matTooltipPosition="above" aria-label="Bookmarked Filters." matTooltipClass="savedViewsBtn">
    <mat-icon>bookmark_add</mat-icon>@if (selectedFilterSet != null) {
    <span> {{truncate(selectedFilterSet.name)}}</span>
  }
</button>
</ngx-material-popover>

<ng-template #popoverContent>
  <!-- <mat-form-field appearance="outline" style="margin-bottom: -1em; width: 300px;">
  <mat-label>Search...</mat-label>
  <input matInput [(ngModel)]="searchVal">
  <mat-icon matSuffix>search</mat-icon>
</mat-form-field> -->
@if (filterSets.length != 0) {
  <ul class="list">
    <mat-selection-list #filterSetList name="fieldName" ngDefaultControl [multiple]="false" [(ngModel)]="selectedFilterSets" (ngModelChange)="filterSetChange($event)">
      @for (filterSet of filterSets; track filterSet) {
        <mat-list-option [value]="filterSet">
          {{filterSet.name}}
        </mat-list-option>
      }
    </mat-selection-list>
  </ul>
}
@if (filterSets.length == 0) {
  <div class="no-filter-sets-container">
    <span class="no-filter-sets-text">No Views Available</span>
  </div>
}
<div class="footer">
  @if (canManipulateFilterSets) {
    <button mat-button color="primary" (click)="addFilterSet()">Save</button>
  }
  @if (canManipulateFilterSets) {
    <button mat-button [disabled]="selectedFilterSet == null" (click)="removeFilterSet()">Remove</button>
  }
  <button mat-button style="float: right" [disabled]="selectedFilterSet == null" (click)="default()">Default</button>
  <mat-icon
    matTooltipPosition="right"
    aria-label="Complete instructions to use Bookmarks"
    matTooltip="To save a custom view, make a selection from your set of filters, then save and name your selection. Once saved, you'll be able to refer back to the saved view at any time."
    matTooltipClass="savedViewsBtn"
    style="margin-left: auto;place-self: center;cursor: pointer;">help_outline
  </mat-icon>
</div>
</ng-template>